import React from 'react';
import ResultTable from '../tables/ResultTable';
// import { historic } from "../../actions/historicActions";

const TablesContainer = props => {
  const { goToRef, results_comment = [] } = props;

  const examTypes = props.uniqES6(props.array.map(e => e.codigo_examen));
  const examNameSorted = [];

  examTypes.forEach(e => {
    examNameSorted.push(props.array.filter(r => r.codigo_examen === e));
  });

  const tables = examNameSorted.map((e, index) => {
    
    const itemsWithComments = e.map(item => {
      
      const comentarioObj = results_comment.find(
        c => c.posicion === item.posicion
      );

      return {
        ...item,
        comentario: comentarioObj ? comentarioObj.comentario : null
      };
    });

    const comentarioAnti = results_comment.find(
      c => c.posicion === 100 //comentario del germen
    )

    return ( 
    <ResultTable
      key={index}
      goToRef={goToRef}
      name={e[0].nombre_examen}
      sample={e[0].origen_muestra}
      items={itemsWithComments}
      comentarioAnti={comentarioAnti}
      patientHistoric={props.patientHistoric}
      selectedPatientID={props.selectedPatientID}
    />
  );
})
  return <div>{tables}</div>;
};

export default TablesContainer;
